import CartService             from '../cart/cartService.js';
import CartToShopCartAdaptor   from './cartToShopCartAdaptor';
import localStorageCartService from './localStorageCartService.js';
import LtoCart                 from './ltoCart.js';

let CartServiceAdaptor = function () {
    let oldCart;

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {
        toJSON: function(){
            return getCart().toJSON();
        },
        addCartItem: function(item){
            let cart = getCart();

            cart.addCartItem(item);
            _setCart(cart);
        },
        addItem: function(sku, qty, maxQty){
            let cart = getCart();

            cart.addItem(sku, qty, maxQty);
            _setCart(cart);
        },
        getItemBySku: function(sku){
            return getCart().getItemBySku(sku);
        },
        getItems: function(){
            return getCart().getItems();
        },
        getCart: function(){
            return getCart();
        },
        setCart: function(cart){
            _setCart(cart);
        },
        resetCart: function(){
            resetCart();
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getCart() {
        if (!oldCart) {
            oldCart = localStorageCartService.getCart();
            if (!oldCart){
                oldCart = new LtoCart();
            }
        }
        return oldCart;
    }

    function _setCart(cart){
        // Set the old cart.
        localStorageCartService.setCart(cart);

        // Set the new cart
        if (typeof(enableEcom3) !== 'undefined' && enableEcom3) { // eslint-disable-line
            // Dump the new cart
            CartService.clearCart();

            // Set the new cart to have the same items as the old cart.
            let callback = function(newCart){
                CartService.setCart(newCart);
            };
            CartToShopCartAdaptor(cart, callback);
        }
    }

    function resetCart(){
        // Reset the old cart.
        localStorageCartService.resetCartCookies();

        // Reset the new cart.
        if (typeof(enableEcom3) !== 'undefined' && enableEcom3) { // eslint-disable-line
            CartService.setCart(null);
        }
    }

    return publicMethods;
}();

export default CartServiceAdaptor;
